import type { ColumnDirection } from '@hotjar/hotsauce';
import type { SortState } from '../SurveyView/SurveyResponsesView/ResponsesList/ResponsesList';

const serverSortKeys: Partial<Record<string, string>> = {
  created_epoch_time: 'created',
};

export const getServerSortField = (sortBy: string, direction: 'asc' | 'desc' | 'none'): string => {
  // Server expects a '-' for reverses sorts.
  const sortPrefix = direction === 'desc' ? '-' : '';
  const key = serverSortKeys[sortBy] ?? sortBy;

  return sortPrefix + key;
};

export const getSearchParamToSortState = (searchParam: string): SortState => {
  let key = decodeURIComponent(searchParam);
  let direction: ColumnDirection = 'asc';

  if (searchParam[0] === '-') {
    key = searchParam.slice(1, searchParam.length);
    direction = 'desc';
  }

  key = key === 'created' ? 'created_epoch_time' : key;

  return { key, direction };
};
